import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { canUsePluginTools } from '../utils/plugin-visibility.util';

/**
 * Blocks the CAD add-in routes wherever the sidebar entries are hidden, so a
 * deep link cannot reach them.
 */
export const pluginGuard: CanActivateFn = () => {
  if (canUsePluginTools()) {
    return true;
  }

  return inject(Router).createUrlTree(['/user/projects']);
};
